import {getCurSecTimestamp, isnull, localGet, localSave} from "../utils/tools";
import {get, postB, postQ, postQB} from "../apiconfig";
import global from "../config/global";
import CryptoJS from "crypto-js";
import {loginOut} from "../pages/live/chat";

export default {
  appConfig(targetAcc, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    // channelId=177 替换
    fetch('/webApp/api/AppConfig/GetConfig?channelId=177').then(response => response.json())
      .then(res => {
          const data = res.data
          try {
            var key = CryptoJS.enc.Utf8.parse("OfJ7Cx7gNETw3ucMV00TF2MSy42O07yM")
            var decrypt = CryptoJS.AES.decrypt(data, key, {
              mode: CryptoJS.mode.ECB,
              padding: CryptoJS.pad.Pkcs7
            })
            let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
            const res = JSON.parse(decryptedStr)
            if (res.effectConfig) {
              localSave('effectConfig', JSON.stringify(res.effectConfig))
            }
          } catch (err) {
            console.log('appConfig / GetConfig', err)
          }
        }
      )
  },
  block(targetAcc, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/Block', ['session=' + localGet(global.key.session), 'targetAccountId=' + targetAcc], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  report(targetAcc, report, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQB('api/Account/Report', ['session=' + localGet(global.key.session), 'targetAccountId=' + targetAcc], report, function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  setDefaultEventLabel(title, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/SetDefaultEventLabel', ['session=' + localGet(global.key.session), 'title=' + title], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  getEventLabelList(successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Account/GetEventLabelList', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  getNewAnchorList(curCount = 0, languageCode = 0, districtType = 1, successCallback = null, failCallBack = null, vueObj) {
    return get('api/Account/GetAnchorListNewByDistrict', ['session=' + localGet(global.key.session), 'currentCount=' + curCount, 'languageCode=' + languageCode, 'districtType=' + districtType], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },
  getPopularAnchorList(curCount = 0, languageCode = 0, districtType = 1, successCallback = null, failCallBack = null, vueObj) {
    return get('api/Account/GetAnchorListPopularByDistrict', ['session=' + localGet(global.key.session), 'currentCount=' + curCount, 'languageCode=' + languageCode, 'districtType=' + districtType], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },
  getFollowingList(curCount = 0, successCallback = null, failCallBack = null, vueObj) {
    return get('api/Account/GetFollowingList', ['session=' + localGet(global.key.session), 'currentCount=' + curCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },
  getUserInfo(userId, successCallback, failCallback, vueObj, showLoading = true, hideLoading = true, session = null) {
    return get('api/Account/GetUserInfo', ['session=' + (isnull(session) ? localGet(global.key.session) : session), 'userId=' + userId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  getAnchorInfo(anchorId, successCallback, failCallback, vueObj, showLoading = true, hideLoading = true) {
    return get('api/Account/GetAnchorInfo', ['session=' + localGet(global.key.session), 'anchorId=' + anchorId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  getAvailableAnchorList(successCallback = null, failCallBack = null, vueObj) {
    return get('api/Account/GetAnchorListAvailable', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   * attribute
   */
  doAttribute(successCallback = null, failCallBack = null, vueObj) {
    let params = global.getLinkParams()
    params.timestamp = getCurSecTimestamp()
    if (isnull(params.media_source))
      params.media_source = ''
    if (isnull(params.campaign))
      params.campaign = ''
    return postB('api/web_download', params, function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/attribute', vueObj)
  },

  /**
   * 获取通话记录
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @return {Promise<void>}
   */
  getCallRecordList(successCallback = null, failCallBack = null, vueObj) {
    return get('api/Account/GetCallRecord', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj);
  },

  /**
   *通过展示ID和名字搜索主播
   * @param search 主播展示id或名字
   * @param successCallback
   * @param failCallback
   * @param vueObj
   */
  searchAnchor(search, successCallback = null, failCallback = null, vueObj, showLoading = false, hideLoading = false) {
    return postQ('api/Account/SearchAnchor', ['session=' + localGet(global.key.session), 'data=' + search], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 通过好评标签搜索主播
   * @param tag
   * @param curCount
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  searchAnchorByTag(tag, curCount = 0, successCallback = null, failCallback = null, vueObj, showLoading = false, hideLoading = false) {
    return postQ('api/Account/SearchAnchorByTag', ['session=' + localGet(global.key.session), 'tag=' + tag, 'currentCount=' + curCount], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 获取最近浏览的主播列表
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  fetchRecentlyViewed(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetAnchorListRencentlyViewed', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 用户浏览主播
   * @param anchorId
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  userViewAnchor(anchorId, successCallback = null, failCallback = null, vueObj) {
    return postQ('api/Account/UserViewAnchor', ['session=' + localGet(global.key.session), 'anchorId=' + anchorId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 重新加载配置信息，目前只有banner
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @return {Promise<void>}
   */
  fetchGlobalCfg(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetGlobalConfig', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },

  /**
   * 获取黑名单
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {undefined}
   */
  fetchBlackList(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetBlacklist', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 通过主播Id获取视频秀列表
   * @param anchorId
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {undefined|Promise<unknown>}
   */
  loadVideoShowList(anchorId, successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetAllVideoShowListByAnchorId', ['session=' + localGet(global.key.session), 'anchorId=' + anchorId], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },

  /**
   * 获取用户账户余额
   */
  getAvailableCoins(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetSelfAvailableCoins', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },

  getMineConsumptionRecord(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetCostRecord', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 获取支付配置
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {Promise<unknown>}
   */
  getPayConfig(successCallback = null, failCallback = null, vueObj) {
    return get('api/Account/GetPayConfig', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },

  cancelBlock(targetAcc, successCallback = null, failCallback = null, vueObj) {
    return postQ('api/Account/CancelBlock', ['session=' + localGet(global.key.session), 'targetAccountId=' + targetAcc], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, false, false);
  },
  /**
   * 重置密码-发送邮箱验证码
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {Promise<unknown>}
   */
  sendEmailCode(email, successCallback = null, failCallback = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/doSendEmailCodeByResetPwd', ['session=' + localGet(global.key.session), 'email=' + email], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 重置密码-验证验证码
   * @param code
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {Promise<unknown>}
   */
  verifyEmailCode(email, code, successCallback = null, failCallback = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/VerifyEmailCodeResetPwd', ['session=' + localGet(global.key.session), 'code=' + code, 'email=' + email], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 重置密码
   * @param newpwd
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {Promise<unknown>}
   */
  updatePwdByEmail(email, newpwd, successCallback = null, failCallback = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/UpdatePwdByEmailCode', ['session=' + localGet(global.key.session), 'newPassword=' + newpwd, 'email=' + email], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 修改密码
   * @param newpwd
   * @param oldnewpwd
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @returns {Promise<unknown>}
   */
  updatePwdByOld(newpwd, oldpwd, successCallback = null, failCallback = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/UpdatePwdByOldPwd', ['session=' + localGet(global.key.session), 'newPassword=' + newpwd, 'oldPassword=' + oldpwd], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },

  /**
   * 删除账号
   * @param successCallback
   * @param failCallback
   * @param vueObj
   * @param showLoading
   * @param hideLoading
   * @returns {Promise<unknown>}
   */
  deleteAccount(successCallback = null, failCallback = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/DeleteAccount', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallback && failCallback(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading);
  },
  /**
   * 退出登录
   * @param successCallback
   * @param failCallBack
   * @param vueObj
   * @param showLoading
   * @param hideLoading
   * @returns {Promise<unknown>}
   */
  doLogout(successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/Logout', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },

  uploadAvatar(avatarUrl, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/Account/UploadAvatar', ['session=' + localGet(global.key.session), 'imageUrl=' + avatarUrl], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },

  uploadCorver(corverUrl, width, height, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Account/UploadCorver', ['session=' + localGet(global.key.session), 'imageUrl=' + corverUrl, 'imageWidth=' + width, 'imageHeight=' + height], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj, false, false)
  },

  uploadPictures(pictures, successCallback = null, failCallBack = null, vueObj) {
    return postQB('api/Account/UploadPictures', ['session=' + localGet(global.key.session)],  {
        picture:pictures
      }
    , function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,false, false)
  },
  updateProfile(name,age,mood,gender, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/Account/EditProfile', ['session=' + localGet(global.key.session),'nickName='+name,'age='+age,'mood='+mood,'gender='+gender], function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,false, false)
  },
  checkInAppPay(params,successCallback = null, failCallBack = null, vueObj){
    return postQB('api/Account/PayWithIAP',['session=' + localGet(global.key.session)],params,function (data) {
      successCallback && successCallback(data, vueObj)
    }, function (code, msg) {
      failCallBack && failCallBack(code, msg, vueObj)
    }, '/webApp', vueObj,false, false)
  }

}



// WEBPACK FOOTER //
// ./src/api/account-api.js